import { Preview } from "@creatomate/preview";
import rearrangeTracks from "./rearrangeTracks";
import { isSubtitleText } from "../../sidebar/tabs/subtitle/utils";

const reorderTracks = async (newTrack: number, preview: Preview): Promise<void> => {
  const subtitle = preview.state?.elements?.find(element => isSubtitleText(element.source.name));
  const track = subtitle?.track || 0;
  if (track < newTrack) await rearrangeTracks(track, "up", preview, newTrack, false); // Do not create additional undo points
};

export default reorderTracks;
